module.exports = __webpack_public_path__ + "static/media/create.7ae8ff68.jpg";